module.exports = __webpack_public_path__ + "static/img/vias.aa3342d6.png";